export enum CACHE_VARIABLES {
    PPL_APP = 'PPLApps',
    EXPIRED = 'Expired',
    NAVBAR_USER = 'navbarUser',
    TOKEN = 'token',
    ONLINE_MODE_APPS = 'onlineModeApps',
    tokenExpiryTime = 'tokenExpiryTime',
    RoutePath = 'pplappsRoutePath',
    APPLICATION_ID = 'applicationId',
    ROUTE_STATE = 'pplappsRouteState',
    APPLICATION_FLOW_PROPERTIES = 'ApplicationFlowProperties',
    REDIRECT_USER = 'redirectUser',
    DARWIN_ENABLED = 'darwinEnabled'
}